import { Trophy, Sparkles } from "lucide-react";

export default function CompetitorsSoon({ status }) {
  const configured = status?.configured;
  return (
    <div
      className="pp-surface p-6 flex flex-col md:flex-row md:items-center gap-5"
      data-testid="competitors-soon"
    >
      <div className="w-11 h-11 border border-[#333C47] bg-[#0F1115] flex items-center justify-center shrink-0">
        <Trophy className="h-5 w-5 text-[#C7CBD1]" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex flex-wrap items-center gap-2 mb-1">
          <div className="pp-label">Competitive Trust Index</div>
          <span
            className="inline-flex items-center gap-1.5 px-2 py-0.5 text-[10px] uppercase tracking-wider font-semibold border"
            style={{
              color: "#EAB308",
              borderColor: "#EAB30855",
              background: "rgba(234,179,8,0.06)",
            }}
            data-testid="competitors-status-pill"
          >
            <Sparkles className="h-3 w-3 text-[#EAB308]" />
            {configured ? "Available" : "Awaiting Google key"}
          </span>
        </div>
        <div className="font-display text-lg text-white leading-snug">
          Beyond star ratings — a true trust comparison against your real local rivals.
        </div>
        <div className="text-sm text-[#C7CBD1] mt-2 leading-relaxed max-w-2xl">
          Phase 2 is built and ready. It uses Google Places to identify three real
          local rivals so you can see exactly why buyers might choose the other guy.
          Add <code className="text-white bg-[#0F1115] px-1 border border-[#333C47]">GOOGLE_MAPS_API_KEY</code> to
          switch this on. Phase 3 will compare every competitor across the same
          eight-category framework.
        </div>
      </div>
    </div>
  );
}
